import { useFeatureFlagValueBool } from "@mirage/service-experimentation/useFeatureFlagValue";

export const useShouldSummarizeNavigateToChat = () => {
  const isOmniboxEnabled = useFeatureFlagValueBool("dash_2025_03_18_omnibox");

  const isConversationEnabled = useFeatureFlagValueBool(
    "dash_2025_02_11_conversation_assistant",
  );
  const shouldSummarizeNavigateToChat =
    isOmniboxEnabled && isConversationEnabled;

  return shouldSummarizeNavigateToChat;
};
